import ServiceBooking from 'components/HappeningNonContent/ServiceBooking/ServiceBooking';

export default ServiceBooking;
